import { AxiosResponse } from 'axios';
import ApiService, { ApiArguments } from '@/api/api_service';
import {
  TranscriptionTimelineApi,
  TranscriptionTimelineApiGetTranscriptionTimelineRequest,
  GetTranscriptionTimeline200Response,
  TranscriptionTimelineApiPostTranscriptionSummarizeInTimelineRequest,
} from '@/api/openapi';

export class TranscriptionTimelineApiService extends ApiService {
  api = new TranscriptionTimelineApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async getTranscriptionTimeline(
    {
      request,
      options,
      errorHandlers,
    }: ApiArguments<TranscriptionTimelineApiGetTranscriptionTimelineRequest>,
  ): Promise<AxiosResponse<GetTranscriptionTimeline200Response>> {
    return this.checkResponse<GetTranscriptionTimeline200Response>(
      this.api.getTranscriptionTimeline(request, options),
      errorHandlers,
    );
  }

  async postTranscriptionSummarizeInTimeline({
    request,
    options,
    errorHandlers,
  }: ApiArguments<TranscriptionTimelineApiPostTranscriptionSummarizeInTimelineRequest>) {
    return this.checkResponse<void>(
      this.api.postTranscriptionSummarizeInTimeline(request, options),
      errorHandlers,
    );
  }
}
